import { Component } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-change-password-2-fa',
  templateUrl: './change-password-2-fa.component.html',
  styleUrls: ['./change-password-2-fa.component.scss'],
})
export class ChangePassword2FAComponent {

  user2FAMethod;
  isSMS: boolean;
  isAuthApp: boolean;
  titlelbl;
  constructor(
    private userSessionService: UserSessionService,
    private config:ConfigService
  ) { }
  
  ionViewDidEnter() {
    this.onGetUserCurrentChoice();
  }

  onGetUserCurrentChoice(){
    this.userSessionService.getCustomer().subscribe((customer: CustomerModel) => {
     
      if (customer) {
        if(null === customer.getCustomDataProperty("MFA_METHOD")){
          this.user2FAMethod = this.config.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
        }else {
          this.user2FAMethod = customer.getCustomDataProperty("MFA_METHOD");
        }
        // if (null !== customer.getCustomDataProperty("MFA_METHOD")) {
          if(this.user2FAMethod){
            this.user2FAMethod === 'SMS' ? this.isSMS = true : this.isAuthApp
            switch (this.user2FAMethod) {
              case 'SMS':
                console.log('SMS')
                this.isSMS = true;
                this.isAuthApp = false;
                this.titlelbl = "Multi-factor authentication";
                break;
              case 'AUTH_APP':
                console.log('AUTH_APP')
                this.isSMS = false;
                this.isAuthApp = true;
                this.titlelbl = "Authentication app";
                break;
              default:
                console.log('DEFAULT')
                this.isSMS = true;
                this.isAuthApp = false;
                this.titlelbl = "Multi-factor authentication";
                break;
            }
          } else {
            console.log('Else')
            this.isSMS = true;
            this.isAuthApp = false;
            this.titlelbl = "Multi-factor authentication";
          }
          console.log(this.user2FAMethod)
        // }
      }
    });
  }

}
